import React, { useId } from "react";

export const BrandOrderMark = ({ className = "", label = "Hacer pedido" }) => {
  const uid = useId().replace(/:/g, "");
  const ids = {
    cream: `petitCream-${uid}`,
    cake: `petitCake-${uid}`,
    berry: `petitBerry-${uid}`,
    gold: `petitGold-${uid}`,
  };

  return (
    <span className={`brand-order-mark ${className}`} aria-label={label} role="img">
      <svg viewBox="0 0 96 96" className="brand-order-mark__svg" aria-hidden="true">
        <defs>
          <linearGradient id={ids.cream} x1="20" y1="22" x2="76" y2="48" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFFDF8" />
            <stop offset="0.62" stopColor="#F8E4C9" />
            <stop offset="1" stopColor="#E5B778" />
          </linearGradient>
          <linearGradient id={ids.cake} x1="22" y1="42" x2="75" y2="78" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FFF1D7" />
            <stop offset="0.43" stopColor="#DCA9B5" />
            <stop offset="0.7" stopColor="#8F2446" />
            <stop offset="1" stopColor="#4B1025" />
          </linearGradient>
          <radialGradient id={ids.berry} cx="38%" cy="28%" r="70%">
            <stop stopColor="#FFE8EF" />
            <stop offset="0.36" stopColor="#B51D49" />
            <stop offset="1" stopColor="#5A0D27" />
          </radialGradient>
          <linearGradient id={ids.gold} x1="23" y1="77" x2="74" y2="77" gradientUnits="userSpaceOnUse">
            <stop stopColor="#B77D2F" />
            <stop offset="0.5" stopColor="#F1CF83" />
            <stop offset="1" stopColor="#A86C25" />
          </linearGradient>
        </defs>

        <g className="brand-order-mark__glimmer">
          <path d="M19 24l2.1 4.5 4.5 2.1-4.5 2.1L19 37.2l-2.1-4.5-4.5-2.1 4.5-2.1L19 24z" />
          <path d="M78 20l1.4 3 3 1.4-3 1.4-1.4 3-1.4-3-3-1.4 3-1.4 1.4-3z" />
        </g>

        <ellipse cx="49" cy="79" rx="27" ry="7.5" fill={`url(#${ids.gold})`} opacity="0.95" />
        <path className="brand-order-mark__shadow" d="M24 75c8 4.8 39.8 5 50.5 0" fill="none" stroke="#4B1025" strokeOpacity=".18" strokeWidth="5" strokeLinecap="round" />

        <g className="brand-order-mark__dessert">
          <path d="M26 42.5c7.5-8.2 17.9-12.1 30.2-10.7 12.1 1.4 20 8.3 22.4 18.7.5 2.2-1.3 4.2-3.6 4.1l-46.6-2.2c-4.2-.2-5.4-6.8-2.4-9.9z" fill={`url(#${ids.cream})`} />
          <path d="M24.7 50.2c12.2 4.4 34.7 6.1 53.4 2.2l-5.3 22.2c-.6 2.5-2.9 4.1-5.5 4.1H32.6c-2.6 0-4.8-1.6-5.4-4.1l-5.1-21.2c-.4-1.8.9-3.8 2.6-3.2z" fill={`url(#${ids.cake})`} />
          <path d="M29.3 60.2c10.7 3.5 29.9 4.7 44.7 1.6l-1.4 6c-14.8 2.6-30.6 2.1-42-1.2l-1.3-6.4z" fill="#FFF8ED" opacity=".92" />
          <path d="M29.1 45.2c7.7 3.1 27.1 5.2 44.9 1.9" fill="none" stroke="#FFFDF8" strokeWidth="5" strokeLinecap="round" opacity=".88" />
          <circle cx="57" cy="27" r="8" fill={`url(#${ids.berry})`} />
          <path d="M58.2 23.1c1.3-5.2 4.4-8.1 9-8.5" fill="none" stroke="#7C8F5F" strokeWidth="2.6" strokeLinecap="round" />
          <circle cx="54.5" cy="24.4" r="1.8" fill="#FFE6ED" opacity=".86" />
        </g>
      </svg>
    </span>
  );
};

export const BrandStepMark = ({ number, active = false, label }) => (
  <span className={`brand-step-mark ${active ? "brand-step-mark--active" : "brand-step-mark--idle"}`} aria-label={label} role="img">
    <span className="brand-step-mark__shine" />
    <span className="brand-step-mark__dessert">
      <span className="brand-step-mark__cream" />
      <span className="brand-step-mark__berry" />
      <span className="brand-step-mark__number">{number}</span>
    </span>
  </span>
);
